export const STATUS = {
  STARTED: 'started',
  CANCELLED: 'cancelled',
  COMPLETED: 'completed',
  SCHEDULED: 'scheduled'
}
